export default "/view/img/ea5c3bee0ce8f1423f20c2339dc8885a.png";